// Enhanced pool information from Lonestar

export const poolColors = [
  { name: "Pacific Blue", description: "Classic vibrant blue" },
  { name: "Caribbean Blue", description: "Tropical turquoise shade" },
  { name: "Fiji Blue", description: "Deep ocean blue" },
  { name: "Sapphire Grey", description: "Elegant grey-blue blend" }
];

export const poolBenefits = [
  {
    title: "5-7 Day Installation",
    description: "Fast on-site installation compared to concrete pools (6-8 weeks)",
    icon: "clock"
  },
  {
    title: "Lifetime Warranty",
    description: "Structural lifetime warranty on fiberglass shell",
    icon: "shield"
  },
  {
    title: "Texas Made",
    description: "100% manufactured in New Braunfels, Texas",
    icon: "map-pin"
  },
  {
    title: "17x Stronger",
    description: "Fiberglass is 17 times stronger than concrete",
    icon: "zap"
  },
  {
    title: "Low Maintenance",
    description: "Smooth, non-porous surface resists algae",
    icon: "sparkles"
  },
  {
    title: "Energy Efficient",
    description: "Better heat retention than concrete pools",
    icon: "battery-charging"
  }
];

export const customFeatures = [
  "Tanning Ledges",
  "Built-in Benches",
  "LED Lighting Systems",
  "Water Features (Waterfalls, Fountains)",
  "Spa Jets & Therapy Seats",
  "Automation Systems",
  "Pool Heaters",
  "Saltwater Systems"
];

export const processSteps = [
  {
    step: 1,
    title: "Design Consultation",
    description: "Choose your pool model, size, and color",
    duration: "1-2 days"
  },
  {
    step: 2,
    title: "Permits & Planning",
    description: "Site assessment and permit approvals",
    duration: "1-2 weeks"
  },
  {
    step: 3,
    title: "Excavation",
    description: "Professional site preparation",
    duration: "1-3 days"
  },
  {
    step: 4,
    title: "Pool Installation",
    description: "Crane delivery and shell placement",
    duration: "1 day"
  },
  {
    step: 5,
    title: "Finishing Touches",
    description: "Plumbing, decking, and final setup",
    duration: "3-5 days"
  }
];
